export const convertSpreadsheetToTsv = (file: string[][]): string => {
  return file.map(row => row.join('\t')).join('\n');
};
